var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "navigationMobile" } },
    [
      _c(
        "div",
        { staticClass: "header-bar" },
        [
          _c(
            "v-btn",
            {
              staticClass: "menu",
              attrs: { small: "", flat: "", fab: "" },
              on: { click: _vm.toggleMenu }
            },
            [_c("v-icon", { attrs: { medium: "" } }, [_vm._v("mdi-menu")])],
            1
          ),
          _vm._v(" "),
          _vm.$route.name && _vm.app.pages[_vm.$route.name]
            ? _c("div", { staticClass: "name" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("camelToReadable")(
                      _vm.app.pages[_vm.$route.name].title
                    )
                  )
                )
              ])
            : _vm.app.ready
              ? _c("div", { staticClass: "name" }, [_vm._v("Page not found")])
              : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "link-buttons",
              attrs: { flat: "", fab: "", small: "" },
              on: {
                click: function($event) {
                  _vm.routeAddQuery("activity")
                }
              }
            },
            [_c("v-icon", { attrs: { medium: "" } }, [_vm._v("mdi-bell")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "link-buttons",
              attrs: { flat: "", fab: "", small: "" },
              on: { click: _vm.openKnowledgeBase }
            },
            [
              _c("v-icon", { attrs: { medium: "" } }, [
                _vm._v("mdi-help-circle")
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "vo-scrim",
        class: { active: _vm.$route.query.menu },
        on: { click: _vm.toggleMenu }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mobile-nav", class: { active: _vm.$route.query.menu } },
        [
          _c(
            "div",
            { staticClass: "nav-links" },
            _vm._l(_vm.app.navigationMobile, function(link, i) {
              return _vm.hasPermissions(link.permissions)
                ? _c(
                    "div",
                    {
                      directives: [{ name: "ripple", rawName: "v-ripple" }],
                      key: i,
                      staticClass: "link",
                      class: { selected: _vm.isSelected(link) },
                      on: {
                        click: function($event) {
                          _vm.updatePage(link, true)
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v(_vm._s(link.icon))]),
                      _vm._v(" "),
                      link
                        ? _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(link.title))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            })
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [{ name: "ripple", rawName: "v-ripple" }],
              staticClass: "account",
              on: {
                click: function($event) {
                  _vm.updatePage({ route: "settings" })
                }
              }
            },
            [
              _c("vo-avatar", {
                staticClass: "avatar",
                attrs: { size: 30, user: _vm.$store.getters.profile }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.$store.getters.profile.fullName))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "footer-box" }, [
            _c("div", { staticClass: "logo" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "links" },
              _vm._l(_vm.app.accountNavMobile, function(link, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "link",
                    on: {
                      click: function($event) {
                        _vm.optionClicked(link)
                      }
                    }
                  },
                  [
                    link
                      ? _c("span", { staticClass: "name" }, [
                          _vm._v(_vm._s(link.title))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    i < _vm.app.accountNavMobile.length - 1
                      ? _c("span", { staticClass: "pipe" }, [_vm._v("|")])
                      : _vm._e()
                  ]
                )
              })
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "activity" } }, [
        _vm.$route.query.activity
          ? _c(
              "div",
              { staticClass: "activity-holder" },
              [_c("vo-activity", { attrs: { mobile: true } })],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b7bd506", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7bd506","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationMobile.vue
// module id = 524
// module chunks = 4